// src/pages/AdminDashboard.js
import React, { useState } from 'react';
import { Tabs, Tab, Box, Typography, Paper } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { isMobile } from 'react-device-detect';

// Your components
import Monitor from './monitor';
import LcSettingsPage from '../../pages/Admin/LcSettings';
import LcEarningsMonitor from '../../pages/Admin/LcEarningsMonitor';
import TotalsDashboard from './gifStats';

import {
  Grid,
  Breadcrumbs
} from '@material-ui/core';
import { Link } from 'react-router-dom';
import Chip from '@material-ui/core/Chip';
import { withStyles, emphasize } from '@material-ui/core/styles';

const StyledBreadcrumb = withStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.grey[100],
    height: theme.spacing(3),
    color: theme.palette.grey[800],
    fontWeight: theme.typography.fontWeightRegular,
    '&:hover, &:focus': {
      backgroundColor: theme.palette.grey[300],
    },
    '&:active': {
      boxShadow: theme.shadows[1],
      backgroundColor: emphasize(theme.palette.grey[300], 0.12),
    },
  },
}))(Chip);

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
    marginTop: theme.spacing(2),
    overflowX: 'hidden', // Prevent horizontal scroll
  },
  tabs: {
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
  tabPanel: {
    padding: isMobile ? theme.spacing(1, 0.5) : theme.spacing(3), // Much less padding on mobile
    [theme.breakpoints.down('xs')]: {
      padding: theme.spacing(1, 0), // Even tighter on small phones
    },
  },
  mobileContainer: {
    padding: isMobile ? '8px' : '20px',
    paddingTop: isMobile ? '4px' : '20px',
  },
}));

function TabPanel(props) {
  const { children, value, index, className, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`admin-tabpanel-${index}`}
      aria-labelledby={`admin-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box className={className}>
          <Typography component="div">{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `admin-tab-${index}`,
    'aria-controls': `admin-tabpanel-${index}`,
  };
}

const AdminDashboard = () => {
  const classes = useStyles();
  const [tabValue, setTabValue] = useState(0);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
    // Optional: scroll to top on tab change (great on mobile)
    window.scrollTo(0, 0);
  };

  return (
    <div className={classes.mobileContainer}>
      {/* Header */}
      {isMobile ? <div>&nbsp;</div> : null}
      <Typography variant={isMobile ? "h5" : "h4"} gutterBottom align="center">
        Admin Monitor Dashboard
      </Typography>

      {/* Breadcrumbs - only show on desktop or as simplified version on mobile */}
      {!isMobile ? (
        <Grid container spacing={2} style={{ marginBottom: 16 }}>
          <Grid item xs={12}>
            <Breadcrumbs aria-label="breadcrumb">
              <StyledBreadcrumb component={Link} to="/companyadmin" label="Club Admin" />
              <StyledBreadcrumb label="Admin Monitor" />
            </Breadcrumbs>
          </Grid>
        </Grid>
      ) : (
        <Box mb={1} textAlign="center">
          <Typography variant="caption" color="textSecondary">
            Club Admin › Dashboard
          </Typography>
        </Box>
      )}

      <Paper className={classes.root} elevation={isMobile ? 1 : 3}>
        <Tabs
          value={tabValue}
          onChange={handleTabChange}
          indicatorColor="primary"
          textColor="primary"
          variant="scrollable"           // Critical for mobile!
          scrollButtons="auto"           // Shows arrows if needed
          aria-label="admin dashboard tabs"
          className={classes.tabs}
        >
          <Tab label={isMobile ? "MEV & Liq" : "MEV & Liquidity Monitor"} {...a11yProps(0)} />
          <Tab label={isMobile ? "LC Settings" : "LC Settings"} {...a11yProps(1)} />
          <Tab label={isMobile ? "LC Earnings" : "LC Earnings Monitor"} {...a11yProps(2)} />
          <Tab label={isMobile ? "GIF" : "GIF & Liquidity"} {...a11yProps(3)} />

        </Tabs>

        {/* Tab Panels */}
        <TabPanel value={tabValue} index={0} className={classes.tabPanel}>
          <Monitor />
        </TabPanel>

        <TabPanel value={tabValue} index={1} className={classes.tabPanel}>
          <LcSettingsPage />
        </TabPanel>

        <TabPanel value={tabValue} index={2} className={classes.tabPanel}>
          <LcEarningsMonitor />
        </TabPanel>
        
         <TabPanel value={tabValue} index={3} className={classes.tabPanel}>
          <TotalsDashboard />
        </TabPanel>
      </Paper>
    </div>
  );
};

export default AdminDashboard;
///////////////////////////////////////////////////////////////////////////////////////////////
// // src/pages/AdminDashboard.js
// import React, { useState } from 'react';
// import { Tabs, Tab, Box, Typography, Paper } from '@material-ui/core';
// import { makeStyles } from '@material-ui/core/styles';

// // Import your existing components
// import Monitor from './monitor'; 
// // Your current big component
// //import LCSettings from './LCSettings';              // The component at /admin/lc-settings
// //import LCEarningsMonitor from './LCEarningsMonitor'; // The component at /admin/lc-earnings

// import LcSettingsPage from '../../pages/Admin/LcSettings'
// import LcEarningsMonitor from '../../pages/Admin/LcEarningsMonitor'
// import {
//   isMobile,
//   isBrowser
// } from 'react-device-detect'
// import { 
//   Grid, 
//   Breadcrumbs
// } from '@material-ui/core';
// import { withStyles, emphasize } from '@material-ui/core/styles';
// import { Link } from 'react-router-dom';
// import Chip from '@material-ui/core/Chip';

// const useStyles = makeStyles((theme) => ({
//   root: {
//     flexGrow: 1,
//     backgroundColor: theme.palette.background.paper,
//     marginTop: theme.spacing(2),
//   },
//   tabPanel: {
//     padding: theme.spacing(3),
//   },
// }));

// const StyledBreadcrumb = withStyles((theme) => ({
//   root: {
//     backgroundColor: theme.palette.grey[100],
//     height: theme.spacing(3),
//     color: theme.palette.grey[800],
//     fontWeight: theme.typography.fontWeightRegular,
//     '&:hover, &:focus': {
//       backgroundColor: theme.palette.grey[300],
//       textDecoration: 'none',
//     },
//     '&:active': {
//       boxShadow: theme.shadows[1],
//       backgroundColor: emphasize(theme.palette.grey[300], 0.12),
//       textDecoration: 'none',
//     },
//   },
// }))(Chip);

// function TabPanel(props) {
//   const { children, value, index, ...other } = props;

//   return (
//     <div
//       role="tabpanel"
//       hidden={value !== index}
//       id={`admin-tabpanel-${index}`}
//       aria-labelledby={`admin-tab-${index}`}
//       {...other}
//     >
//       {value === index && (
//         <Box className={props.className || ''} p={3}>
//           <Typography component="div">{children}</Typography>
//         </Box>
//       )}
//     </div>
//   );
// }

// function a11yProps(index) {
//   return {
//     id: `admin-tab-${index}`,
//     'aria-controls': `admin-tabpanel-${index}`,
//   };
// }

// const AdminDashboard = () => {
//   const classes = useStyles();
//   const [tabValue, setTabValue] = useState(0);

//   const handleTabChange = (event, newValue) => {
//     setTabValue(newValue);
//   };

//   return (
//     <div style={{ padding: '20px' }}>
//       <Typography variant="h4" gutterBottom>
//         Administration Monitor Dashboard
//       </Typography>
//         {isMobile ? <div>&nbsp;</div> : null}
//           <Grid container spacing={2}>

//             <Grid item xs={12} sm={6}>
//               <Breadcrumbs aria-label="breadcrumb">
//                 <StyledBreadcrumb component={Link} to="/companyadmin" label="Club Admin" />
//                 <StyledBreadcrumb label="MEV Stats" />
//               </Breadcrumbs>
//             </Grid>
//           </Grid>
          
//       <Paper className={classes.root}>
//         <Tabs
//           value={tabValue}
//           onChange={handleTabChange}
//           indicatorColor="primary"
//           textColor="primary"
//           variant="fullWidth"
//           aria-label="admin dashboard tabs"
//         >
//           <Tab label="MEV & Liquidity Monitor" {...a11yProps(0)} />
//           <Tab label="LC Settings" {...a11yProps(1)} />
//           <Tab label="LC Earnings Monitor" {...a11yProps(2)} />
//         </Tabs>

//         <TabPanel value={tabValue} index={0} className={classes.tabPanel}>
//           <Monitor />
//         </TabPanel>

//         <TabPanel value={tabValue} index={1} className={classes.tabPanel}>
//           <LcSettingsPage />
//         </TabPanel>

//         <TabPanel value={tabValue} index={2} className={classes.tabPanel}>
//           <LcEarningsMonitor />
//         </TabPanel>
//       </Paper>
//     </div>
//   );
// };

// export default AdminDashboard;